import {Component, input} from '@angular/core';

interface Song {
  title: string;
  artist: string;
}

@Component({
  selector: 'app-song-info',
  standalone: true,
  imports: [],
  templateUrl: './song-info.component.html',
  styleUrl: './song-info.component.scss'
})
export class SongInfoComponent {
  // Input for current song data
  currentSong = input<Song | null>(null);
}
